import { ErrorToast } from "../../shared/index";
import Constants from "../../constants/constants";
const CheckLogin = (expire, lastLogin, setLogin, token, previousValues) => {
  // eslint-disable-next-line no-extend-native
  Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
  };
  let expireTime = parseInt(expire);
  expireTime = expireTime / 3600;
  let loginTime = new Date(lastLogin);
  let loginExpireTime = loginTime.addHours(expireTime);
  if (loginExpireTime < new Date()) {
    if (
      previousValues.current.token === token &&
      previousValues.current.lastLogin === lastLogin
    ) {
      setLogin(false);
      ErrorToast(Constants.serverErrorAuthExpire);
      previousValues.current = { lastLogin, token };
    }
  }
  if (!token) setLogin(false);
};
export default CheckLogin;
